import Messages from './APIMessageRepository';

export default {
  methods: {
    writeMessage: function(message) {

      if (this.ConversationId==0) return

      let params = {
        'message': message
      }

      Messages.createMessage(this.ConversationId,params).then( (res)=>{
        
        if(res.status==201){
          this.$root.$emit("component_message", message);
          this.message = "";        
          if (res.response.data.id>0){
            this.$root.$emit("add_tomessage",message);
            this.$root.$emit("changeLastConversationInList",message,res.response.data.created_at)
          } 
        }  
      })
      
    },
    writingMessage: function(event) {
      let char = String.fromCharCode(event);
      if (char != "13") {
        this.$root.$emit("writing_message");
      }
    },
    checkInput: function() {
      if (this.message == "") {
        this.$root.$emit("deleted_message");
      }
    }
  },
  mounted() {       
    this.$root.$on('manageChatStatus', function(value,ConversationId){

        if (value) {
          this.ConversationId = ConversationId
        }else{
          this.ConversationId = 0
        }
        
        this.disableInput=!value

    }.bind(this))
  },
};